import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserMetadata } from './browser-metadata';
import { detectBrowser, detectDeviceType, detectOs } from './capture-utils';
import { RedactionService } from '../../security/redaction.service';
import { RouteMaskService } from '../../security/route-mask.service';

@Injectable({
  providedIn: 'root',
})
export class BrowserMetadataService {
  private readonly router = inject(Router);
  private readonly redactionService = inject(RedactionService);
  private readonly routeMaskService = inject(RouteMaskService);

  buildBrowserMetadata(): BrowserMetadata {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const currentUrl = this.router.url || window.location.pathname + window.location.search + window.location.hash;
    const route = this.routeMaskService.maskRoute(currentUrl || '/');
    const url = this.redactionService.redactUrl(window.location.href || `${window.location.origin}/`);

    return {
      route,
      url,
      timestamp: new Date().toISOString(),
      browser: detectBrowser(),
      os: detectOs(),
      deviceType: detectDeviceType(viewportWidth),
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        devicePixelRatio: window.devicePixelRatio || 1,
        resolution: `${window.screen.width}x${window.screen.height}`,
        viewportWidth,
        viewportHeight,
      },
    };
  }
}
